var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-center mt-5"},[_c('first-heading',{attrs:{"title":_vm.title}}),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('b-spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }